import angular from 'angular';
import find from 'underscore/modules/find.js';
import {userPoolFeature} from '../config/feature';
import {guard, IS_HTML} from '@acng/frontend-rubicon';
import {onClick} from '../../layout/service/worker.js';
import {put} from '../../core/service/backend.js';
import {window} from '@acng/frontend-bounty';
import {portal} from '../../core/portal.js';
import {UPGRADE} from '@acng/frontend-stargazer';

angular.module('userPool').factory('director', ['$rootScope', '$location', 'user', 'onsOverlay', 'passwordResetToken', '$injector', 
  /**
   * @param {angular.IRootScopeService} $rootScope
   * @param {angular.ILocationService} $location
   * @param {import('acng/userPool/factory/user').User} user
   * @param {import('acng/core/service/overlay').OverlayConstructor} onsOverlay
   * @param {string} passwordResetToken
   * @param {angular.auto.IInjectorService} $injector
   */
  function ($rootScope, $location, user, onsOverlay, passwordResetToken, $injector) {
    const {localStorage} = window;

    /**
     * @type {string | false}
     */
    var _passwordResetToken = passwordResetToken;
    /**
     * @type {string | null}
     */
    var signupEmail = null;
    var showDoiHint = false;
    var showChangeEmail = false;
    var showRequestMailDoi = false;
    var wait = false;
    var rename = false;
    var hadRename = false;
    let fskDisclaimerDone = !!localStorage.getItem('fskDisclaimerDone');

    function init() {
      $rootScope.$on('userPool.popups', function (_event, popups) {
        // TODO Trigger from core/service/backend / httpInterceptor
        if (find(popups, { 'template': 'doiHint' })) {
          showDoiHint = true;
        }
        if (find(popups, { 'template': 'renameOverlay' })) {
          rename = !hadRename;
        }
        if (find(popups, { 'template': 'changeEmail' })) {
          showChangeEmail = true;
        }
        if (find(popups, { 'template': 'requestMailDoi' })) {
          showRequestMailDoi = true;
        }
      });

      $rootScope.$on('userPool.login.success', function () {
        // TODO these are many!
        wait = false;
        triggerUserPopups();

        if (user.redirectPath) {
          $location.path(user.redirectPath).replace();
          user.redirectPath = null;
        } else {
          var redirectPaths = ['signup', 'login', 'reactivate'];

          if (RegExp('/(' + redirectPaths.join('|') + ')', 'i').test($location.path())) {
            $location.path('/').replace();
          }
        }
      });
    }

    /**
     * @param {string} email
     */
    function setSignupEmail(email) {
      signupEmail = email;
    }

    /**
     * @param {string} token
     */
    function setPasswordResetToken(token) {
      _passwordResetToken = token;
    }

    return {
      'init': init, // ../../core/0core.js:13
      'setSignupEmail': setSignupEmail, // ../service/signup.js:40
      'setPasswordResetToken': setPasswordResetToken, // ../service/signup.js:45
      'triggerUserPopups': triggerUserPopups, // ../service/signup.js:51
      'setWait': () => (wait = true),
    };

    function livecam() {
      if (!$injector.has('Livecam')) return false;

      return $injector.get('Livecam').isActive();
    }

    function triggerUserPopups() {
      if (wait || livecam()) return;

      if (!user.guest) {

        if (_passwordResetToken) {
          onsOverlay.create('passwordSetOverlay', {
            'email': user.email,
            'token': _passwordResetToken
          })
            .disableBackdrop()
            .disableCloseButtonInToolbar()
            .open();

          _passwordResetToken = false;
        } else if (rename) {
          onsOverlay.create('renameOverlay')
            .disableBackdrop()
            .disableCloseButtonInToolbar()
            .open();

          rename = false;
          hadRename = true;
        } else if (portal.fsk.disclaimer && user.fsk < 18 && !fskDisclaimerDone) {
          fskDisclaimerDone = true;

          userPoolFeature.popup(null, 'fsk-disclaimer', (close) => ({
            /**
             * @type {import('@acng/frontend-stargazer').Controller}
             */
            click: {
              [UPGRADE](node) {
                ASSERT: guard(node, IS_HTML);
                onClick(node, async () => {
                  localStorage.setItem('fskDisclaimerDone', 'true');
                  close();
                  await put('user/fsk', {fsk: node.dataset.level});
                });
              },
            },
          }));
        } else if (showDoiHint) {
        // soi
          const doiHint = onsOverlay.create('doiHint')
            .disableBackdrop()
            .open();

          showDoiHint = false;
        } else if (showChangeEmail) {
          onsOverlay.create('changeEmailOverlay')
            .disableBackdrop()
            .open();
          showChangeEmail = false;
        } else if (showRequestMailDoi) {
          onsOverlay.create('requestMailDoiOverlay')
            .disableBackdrop()
            .open();
          showRequestMailDoi = false;
        }

      } else if (signupEmail) {
      // doi
        onsOverlay.create('doiHint', { 'signupEmail': signupEmail })
          .disableBackdrop()
          .disableCloseButtonInToolbar()
          .open();

        showDoiHint = false;
        signupEmail = null;
      }
    }

  }
]);
